import Breadcrumb from '#client/components/common/Breadcrumb/Breadcrumb';
import { SessionContext } from '#client/contexts/SessionContext';
import { useProgramStore } from '#client/stores/program/useProgramStore';
import { Spinner } from '@shopify/polaris';
import { useContext, useMemo } from 'react';

export default function ProgramBreadcrumbs() {
    // Zustand store for program mode and name
    const mode = useProgramStore.use.mode();
    const name = useProgramStore.use.name();

    const { isCustomerAuthenticated } = useContext(SessionContext);

    const baseUrl = isCustomerAuthenticated ? '/customer/programs' : '/program-management';
    const breadcrumbItems = useMemo(
        () =>
            mode === 'create'
                ? [{ label: 'Programs', url: baseUrl }]
                : [{ label: 'Programs', url: baseUrl }, { label: !name ? <Spinner size="small" /> : (name && name.toString()) || 'Untitled Program' }],
        [mode, name]
    );

    return <Breadcrumb items={breadcrumbItems} />;
}
